import React from 'react';
import styled from 'styled-components';
import colors from '../../../theme/colors';
import TopmenuButton from './TopmenuButton';

const StyledButtonClose = styled(TopmenuButton)`
  border: none !important;
  ${(props) => props.theme.mediaQuerie.minWidth.md} {
    margin: 0 16px 0 120px;
  }
  outline: none;
  cursor: pointer;

  :hover{
    background-color: transparent !important;
  }
`;

const ButtonClose = (props: any) => {
  const { className } = props;
  return (
    <StyledButtonClose type="button" borderLeft className={`button-close ${className}`} {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 6L18.7742 18.7742"
          stroke={colors.secondary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 18.7742L18.7742 5.99998"
          stroke={colors.secondary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </StyledButtonClose>
  );
};

export default ButtonClose;
